module.exports = __webpack_public_path__ + "b6ca1ade5390b8eb59c45c31baced5e5.png";